import { get } from 'lodash';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

const GET_PROVIDER_PROCEDURES = gql`
    query getProviderProcedures($providerId: String, $directoryId: String) {
        provider(id: $providerId, directoryId: $directoryId) {
            id
            procedures {
                id
                name
                show911Notice
            }
        }
    }
`;

const withProviderProcedures = graphql(GET_PROVIDER_PROCEDURES, {
    skip: ownProps => {
        return !ownProps.providerId;
    },
    options: ownProps => {
        return {
            ssr: false,
            variables: {
                providerId: ownProps.providerId,
                directoryId: '-1',
            },
        };
    },
    props: ({ ownProps, data }) => {
        if (data.loading) return { providerProceduresLoading: true };
        if (data.error) return { hasErrors: true };
        const procs = {};
        const procedures = get(data, 'provider.procedures', []);
        procedures.forEach(proc => {
            procs[proc.id] = {
                show911Notice: proc.show911Notice,
                name: proc.name,
            };
        });

        return {
            ...ownProps,
            procedures: procs,
        };
    },
});

export default withProviderProcedures;
